import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import {AppSettings} from '../../app-settings';
import {PasswordService} from '../../Services/password.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private passwordservice: PasswordService ,private router:Router) { }
  ngOnInit() {
  }

	forgotPassFrom = new FormGroup({
		email:new FormControl()
	});

	errormsg : String;
	isError: Boolean;

	onEmailSubmit()
	{
		//console.log(this.forgotPassFrom.value.email);
		var useremail = this.forgotPassFrom.value.email;
		console.log(useremail);
		this.CheckEmptyField(useremail);
		if(!this.isError)
		this.emailValidator(useremail);
	    if(!this.isError)
		this.userExists(useremail);
	}

	CheckEmptyField(useremail)
	{
		if(useremail =='')
		{
			this.errormsg ="Please enter your email id";
			this.isError = true;
		}
		else
		{
			this.isError = false;
		}
	}

	emailValidator(email) {

        var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!EMAIL_REGEXP.test(email)) 
        {
            this.errormsg ="Please enter a valid email id";
            this.isError = true;
        }
        else
        {
        	this.isError = false;
        	this.errormsg ="Please enter a valid email id";
        }
    }

    userExists(useremail)
    {
    	if(!this.isError)

    		this.passwordservice.checkUserExists(AppSettings.restApiUrl+'/api/public/user/exists?username='+useremail).subscribe(data =>{

    			if(!data)
    			{
    				this.errormsg ="This ID is not registerd";
					this.isError = true;
    			}
    			else
    			{
    				this.isError = false;
    				this.submitUserName();
    			}
    		},

			resuserEmail =>{
			
				this.errormsg ="This ID is not registerd";
				this.isError = true;	
		});

    }

    submitUserName()
    {
    	 this.passwordservice.submitPassword(AppSettings.restApiUrl+'/api/public/user/forgotPassword' , 
			{username:this.forgotPassFrom.value.email}).subscribe(data =>{

				 this.router.navigate(['/reset-success']);
			},

			resuserEmail =>{if((resuserEmail.status)== '404')
			{
				this.errormsg ="This ID is not registerd";
				this.isError = true;
			}
		});
    }
 
}
